import { render, staticRenderFns } from "./Birthdays.vue?vue&type=template&id=f57be6da&scoped=true&"
import script from "./Birthdays.vue?vue&type=script&lang=js&"
export * from "./Birthdays.vue?vue&type=script&lang=js&"
import style0 from "./Birthdays.vue?vue&type=style&index=0&id=f57be6da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57be6da",
  null
  
)

export default component.exports